<template>
	<!-- Vue Material Menu -->
	<!-- https://vuematerial.io/components/menu -->

	<md-menu
		:md-direction="direction"
		:md-size="size"
		md-close-on-click
		class="ui-menu"
	>
		<ui-button
			:icon="icon"
			:text="label"
			md-menu-trigger
		/>
		<md-menu-content style="max-height: calc(100vh - 48px)">
			<slot/>
		</md-menu-content>
		<md-tooltip
			v-if="tooltip"
			class="ui-menu-tooltip"
		>
			{{ tooltip }}
		</md-tooltip>
	</md-menu>
</template>

<script>
import UiButton from "lib/components/ui/Button";

export default {
	name: "Menu",
	components: {
		UiButton
	},
	props: {
		direction: {
			type: String,
			default: "bottom-end", // bottom-start, bottom-end, top-start, top-end
			required: false
		},
		icon: {
			type: String,
			default: "",
			required: false
		},
		label: {
			type: String,
			default: "",
			required: false
		},
		size: {
			type: String,
			default: "big", // small, medium, big, huge, auto
			required: false
		},
		tooltip: {
			type: String,
			default: "",
			required: false
		}
	}
};
</script>

<style scoped>
.ui-menu-tooltip {
	z-index: 8;
}
</style>
